
/**
 * --- External Imports ---
 */
import { useMemo } from "react";
import { SWRConfiguration, SWRResponse } from "swr";

/**
 * --- Internal Imports ---
 */
import { GetTrials, GetTrialsResponse } from "@/apis/dtos";
import useGet from "../apis/useGet";

/**
 * --- Hook ---
 */
const getData = (response?: SWRResponse<GetTrialsResponse, GetTrialsResponse>) => response?.data?.trials;
const getError = (response?: SWRResponse<GetTrialsResponse, GetTrialsResponse>) => (response?.error ?? response?.data)?.responseStatus;
const getAdditionalState = (_?: SWRResponse<GetTrialsResponse, GetTrialsResponse>) => ({});

const useGetTrials = (query?: Partial<GetTrials>, configuration?: SWRConfiguration) => {
    const request = useMemo(() => {
        if (!query) {
            return undefined;
        }

        return () => {
            return new GetTrials(query);
        }
    }, [query]);

    return useGet(request, { getData, getError, getAdditionalState }, configuration);
}

export default useGetTrials;